module.exports = __webpack_public_path__ + "3fcf59ce4ab815b3f963f201ed526b6a.jpeg";